import { Component, OnInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { CountryModel } from '../../../api/country/country';
import { CountryService } from '../../../api/country/country.service';
import { ApiConstant } from '../../../api/api.constant';
import { MasterDataConstant } from '../../../api/masterdata.constant';
declare var $: any;
declare var jQuery: any;
declare var swal: any;
@Component({
    selector: 'country-page',
    templateUrl: './country.html'
})
export class CountryComponent implements OnInit {
    countries: CountryModel[];
    cUserActive: boolean;
    message: string;
    length: number;
    constructor(
        private masterdataservice : MasterDataConstant,
        private router: Router, 
        private apiservice: ApiConstant, 
        private countryService: CountryService, 
        private element: ElementRef) { }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN')) {
            $(function () {
                $("#example-numbers").steps({
                    headerTag: "h3",
                    bodyTag: "section",
                    transitionEffect: "fade",
                    autoFocus: true
                });
            })
            this.getAllCountry();
        } else {
            this.router.navigate(['/']);
        }
    }
    getAllCountry() {
        this.countryService
            .allCounty()
            .then(data => {
                this.masterdataservice.CountryList = [];
                if (data != undefined) {
                    this.countries = data;
                    this.length = 1;
                } else {
                    this.length = 0;
                }
            });
    }
    countryInsert() {
        this.countryService.bulkinsert().then(data => {
            if (data.status) {
                var jdata = {
                    key: 'country'
                }
                $.notify({
                    message: data.message
                }, {
                    type: 'success',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 200
                });
                this.masterdataservice.CountryList = [];
            } else {
                $.notify({
                    message: data.message
                }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 200
                });
            }
        });
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/country/country.page.ts